import popupStyles from "./alternativeAppointmentPopup.module.css";
import doctor from "../../../images/questionnaire_doctor.png";
import { IPopupWithoutProps } from "../../../types/types";
import { useNavigate } from "react-router-dom";
import CloseButton from "../../closeButton/closeButton";
import { getDuration } from "../../../utils/utils";
import { TCalendarAppointment } from "../../../services/types/user.types";

interface IAlternativeAppointmentPopup extends IPopupWithoutProps {
    appointmentData: TCalendarAppointment;
}
function AlternativeAppointmentPopup({
    onClose,
    appointmentData,
}: IAlternativeAppointmentPopup) {
    const appointmentDate = new Date(appointmentData.appointmentDate)


    const navigate = useNavigate();

    return (
        <article className={popupStyles.popup}>
            <CloseButton onClick={onClose} />
            <h2 className={popupStyles.popup__title}>!נוצרה פגישה חילופית בהצלחה</h2>
            <img
                src={doctor}
                alt="תמונה של וונצ’י"
                className={popupStyles.popup__img}
            />
            <p className={popupStyles.popup__text}>תאריך פגישה חדשה</p>
            <p className={popupStyles.popup__text_big}>
                {`${appointmentDate.getDate()}/${appointmentDate.getMonth() + 1
                    }/${appointmentDate.getFullYear()}`}
            </p>
            <p className={popupStyles.popup__text}>שעת פגישה חדשה</p>
            <p className={popupStyles.popup__text_big}>
                {getDuration(appointmentDate, appointmentData.startTime ?? "00:00", appointmentData?.endTime ?? "00:50")}
            </p>
            <p className={popupStyles.popup_text_info}>
                ניתן להיכנס לאזור יומן פגישות ולצפות בפגישות שנקבעו. בלחיצה על הפגישה
                ניתן לצפות בפרטים המלאים.
            </p>

            <button
                className={`button ${popupStyles.popup__btn} ${popupStyles.popup__btn_type_calendar} hover`}
                onClick={() => {
                    navigate("/treatment", {
                        replace: true,
                        state: { pathname: "myCalendar" },
                    });
                    onClose();
                }}
            >
                לאזור יומן פגישות
            </button>
            <button
                className={`button ${popupStyles.popup__btn} ${popupStyles.popup__btn_disabled} hover`}
                onClick={() => {
                    navigate("/treatment/search");
                    onClose();
                }}
                disabled={true}
            >
                לתיאום פגישה נוספת
            </button>
        </article>
    );
}

export default AlternativeAppointmentPopup;
